import { defineComponent as n, createElementBlock as r, createCommentVNode as l, openBlock as o, createElementVNode as s, createVNode as a, unref as i, toDisplayString as t } from "vue";
import { ScalarIconBook as c } from "@scalar/icons";
const d = {
  key: 0,
  class: "group flex items-center last:border-r-0 xl:border-r xl:first:ml-auto"
}, m = ["href"], p = {
  key: 0,
  class: "ml-1 empty:hidden"
}, u = {
  key: 1,
  class: "ml-1 empty:hidden"
}, v = /* @__PURE__ */ n({
  __name: "ExternalDocs",
  props: {
    value: {}
  },
  setup(f) {
    return (e, h) => e.value ? (o(), r("div", d, [
      s("a", {
        href: e.value.url,
        class: "text-c-1 hover:bg-b-2 mr-2 flex min-h-7 min-w-7 items-center rounded-lg border px-2 py-1 no-underline group-last:mr-0 xl:border-none",
        target: "_blank",
        rel: "noopener noreferrer"
      }, [
        a(i(c), {
          weight: "bold",
          class: "size-3 text-current"
        }),
        e.value.description ? (o(), r("span", p, t(e.value.description), 1)) : (o(), r("span", u, t(e.value.url), 1))
      ], 8, m)
    ])) : l("", !0);
  }
});
export {
  v as default
};
